import useMediaQuery from '@mui/material/useMediaQuery';

import ebg from './assets/Logos/ebg.png';
import gwg from './assets/Logos/gwg.png';
import nhg from './assets/Logos/nhg.png';
import sgk from './assets/Logos/sgk_vobis.svg';
import sgl from './assets/Logos/sgl.jpg';
import wbg from './assets/Logos/wbg.svg';

export const isBigScreen = (): boolean => useMediaQuery('min-width: 1824px)');
export const isTabletOrMobile = (): boolean =>
  useMediaQuery('(max-width: 1224px)');
export const isPortrait = (): boolean =>
  useMediaQuery('(orientation: portrait)');

export const numberFormatter = (number: number) =>
  number.toLocaleString('de-DE', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

export const numberFormatterInEuro = (number: number) =>
  `€ ${number.toLocaleString('de-DE', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  })} `;

export enum Rebrandings {
  'ebg' = 'ebg',
  'nhg' = 'nhg',
  'sgk' = 'sgk',
  'gwg' = 'gwg',
  'wbg' = 'wbg',
  'sgl' = 'sgl',
  'ebg-staging' = 'ebg-staging',
}

type RebrandingTypes = { [key in Rebrandings]: string };

const getLogoForClient = (): RebrandingTypes => ({
  wbg,
  ebg,
  sgk,
  gwg,
  nhg,
  sgl,
  'ebg-staging': ebg,
});

export { getLogoForClient };
